module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("abdYs"))).then(() => parcelRequire('hEqeo'));